module.exports = __webpack_public_path__ + "assets/retina_T2_CircleDetailed.9904508108dca2f63cfb9a1d31815fb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_T2_CircleDetailed.png
// module id = 727
// module chunks = 0